/**
 * Validates the maximum length that can be entered in an input. Primarily used for TextAreas in IE
 * since IE doesn't support the maxLength attribute.
 *
 */
import Validator from 'utils/validators/MultiFieldValidator';
import Personalizer from 'utils/Personalizer';
import NumberParser from 'utils/parsers/NumberParser';

var Errors = {
    MaxTimeExceeded: 'max_time_exceeded',
    UnderMinTime: 'under_min_time'
};

var ElapsedTimeValidator = Validator.extend({
    /**
     *
     * @param args
     *
     *      maxTime: Maximum elapsed time in seconds
     */
    initialize: function(args) {
        if (!args.maxTime) {
            throw 'ElapedTimeValidator requires maxTime.';
        }

        this.maxTime = args.maxTime;
        this.minTime = args.minTime;

        this.initializeMultifieldValidator(args);

        var _this = this;
        this.$inputField.each(function(index, element) {
            jQuery(element).bind('keydown', function(e) {
                _this.validCharacterKeydownHandler(e);
            });
        });

        if (!this.parser) {
            this.parser = new NumberParser({
                numberSeparator: Personalizer.getNumberSeparator()
            });
        }

        if (typeof args.typeFormat != 'undefined' && args.typeFormat == 'integer') {
            this.typeFormat = args.typeFormat;
            //tab backspace arrows delete end, home
            this.validChars = [8, 9, 37, 38, 39, 40, 46, 35, 36];
        } else {
            this.typeFormat = 'decimal';
            //tab backspace arrows delete decimal comma period, end, home
            this.validChars = [8, 9, 37, 38, 39, 40, 46, 110, 188, 190, 35, 36];
        }
    },

    /**
     * Needs to be overridden by the deriving validator to combine the multiple fields into a single value.
     * @returns {string}
     */
    getTargetValue: function() {
        try {
            var hours = this.parser.parse(this.$inputField[0].val()) || 0;
        } catch (err) {
            hours = 0;
        }

        try {
            var minutes = this.parser.parse(this.$inputField[1].val()) || 0;
        } catch (err) {
            minutes = 0;
        }

        try {
            var seconds = this.parser.parse(this.$inputField[2].val()) || 0;
        } catch (err) {
            seconds = 0;
        }

        try {
            var milliseconds = this.parser.parse(this.$inputField[3].val()) || 0;
        } catch (err) {
            milliseconds = 0;
        }

        return (milliseconds / 1000.0 + seconds + 60 * minutes + 3600 * hours).toString();
    },

    validateInput: function(value) {
        if (value > this.maxTime) {
            return Errors.MaxTimeExceeded;
        } else if (!isNaN(this.minTime) && value < this.minTime) {
            //need to populate the fields because the user can otherwise remove values one by one
            this.populateFields(value);
            return Errors.UnderMinTime;
        } else {
            this.populateFields(+value);
            return '';
        }
    },

    populateFields: function(value) {
        this.$inputField[0].val(Math.floor(value / 3600));
        this.$inputField[1].val(Math.floor((value % 3600) / 60));
        this.$inputField[2].val(Math.round(Math.floor(value % 3600) % 60));
        this.$inputField[3].val(Math.round((value % 1) * 1000));
    },

    /**
     * This is a handler that can be wired up to a keydown event by derived validators. The validChars
     * array will need to be defined by that object as well.
     * @param e
     * @returns {boolean}
     */
    validCharacterKeydownHandler: function(e) {
        var oe = e.originalEvent;
        var ch = typeof oe.which == 'number' ? oe.which : oe.keyCode;

        var allow = false;

        if (this.isNumberKeyCode(ch)) {
            allow = true;
        } else if (this.validChars.indexOf(ch) > -1) {
            allow = true;
        }

        if (!allow) {
            e.preventDefault();
            return false;
        }

        // return undefined
    },

    isNumberKeyCode: function(ch) {
        return !this.isNotANumberKeyCode(ch);
    },

    isNotANumberKeyCode: function(ch) {
        return ch < 48 || (ch > 57 && ch < 96) || ch > 105;
    }
});
ElapsedTimeValidator.ValidationErrors = Errors;
export default ElapsedTimeValidator;
